import { render, staticRenderFns } from "./CenterResponseQueue.vue?vue&type=template&id=133cf66c&scoped=true&"
import script from "./CenterResponseQueue.vue?vue&type=script&lang=js&"
export * from "./CenterResponseQueue.vue?vue&type=script&lang=js&"
import style0 from "./CenterResponseQueue.vue?vue&type=style&index=0&id=133cf66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cf66c",
  null
  
)

export default component.exports